import React, { useCallback, useRef, useEffect, useState } from 'react';
import 'twin.macro';
import { loginDumpert } from 'services/user';
import { signInFirebase } from 'services/auth';
import { documentSetCookie } from '../../cookie';
import { NavLink } from 'react-router-dom';
import { Input } from '../form';
import { Button } from '../button';
import { Icon } from '../icon';
import { LoaderIcon } from 'icons';
import { gaEvent } from 'services/ga';
import { Small } from '../text';
import { notifyError } from '../notifications';

export const LoginForm = ({ focused = false }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginPending, setLoginPending] = useState(false);
  const formRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    focused && inputRef.current.focus();
  }, []);

  const submit = useCallback(
    async (e) => {
      e.preventDefault();
      setLoginPending(true);
      let tokenObtained = false;
      try {
        const {
          data: { token },
        } = await loginDumpert(username, password);
        tokenObtained = true;
        const { user } = await signInFirebase(token);
        const idToken = await user.getIdToken();
        documentSetCookie('access_token', idToken);
        gaEvent('dmp_user', 'login');
      } catch (error) {
        if (
          !tokenObtained &&
          error.response &&
          error.response.data &&
          error.response.data.message !== ''
        ) {
          notifyError(error); // backend error
        } else if (tokenObtained) {
          notifyError('Er gaat iets mis bij het aanmelden.'); // Firebase error
        } else {
          notifyError('Er gaat iets mis, controleer je email en wachtwoord.'); // generic login error if backend didn't cover it
        }
      } finally {
        setLoginPending(false);
      }
    },
    [username, password],
  );

  return (
    <>
      <form tw='text-left' onSubmit={submit} ref={formRef}>
        <Input
          id='login-email'
          label='E-mail'
          type='email'
          placeholder='E-mail'
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          ref={inputRef}
          requiredField
          hasInlineAsterisk
          autoComplete='email'
        />
        <Input
          id='login-password'
          label='Wachtwoord'
          type='password'
          placeholder='Wachtwoord'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          requiredField
          hasInlineAsterisk
          autoComplete='password'
        />
        <div tw='flex justify-between'>
          <div tw='flex items-center mb-1'>
            <Input type='checkbox' tw='mr-2 mt-0' />
            <Small tw='truncate'>onthoud mij</Small>
          </div>
          <Small tw='text-brand cursor-pointer'>
            <NavLink to='/wachtwoord/vergeten'>Wachtwoord vergeten?</NavLink>
          </Small>
        </div>
        <Button
          label={
            !loginPending ? (
              'inloggen'
            ) : (
              <Icon Type={LoaderIcon} tw='animate-spin h-5' color='input-back' size='small' />
            )
          }
          primary
          tw='mt-4 mx-auto'
          type='submit'
          disabled={!(username && password)}
        />
      </form>
    </>
  );
};
